import { ThemeType } from 'theme/jss-types';
import { commonStyleSheet, getFontColorFromHSL } from '../../library/common-styles';
/* eslint-disable max-len */
export const remittanceReportStyles = (theme: ThemeType) => ({
    ...commonStyleSheet(theme),
    main: {
        width: '100%',
        padding: '5px 6px 6px 3px',
        height: '100%',
    },
    footer: {
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F7F7F7',
    },
    filters: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    extraFilters: {
        width: '100%',
        borderRadius: '0 2px 0 0',
        backgroundColor: '#FFFFFF',
        padding: '8px 16px',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
        flexDirection: 'row',
    },
    leftFilters: {
        display: 'flex',
        alignItems: 'center',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input': {
            height: 28,
            borderRadius: 4,
        },
    },
    rightFilters: {
        display: 'flex',
        alignItems: 'center',
        '& .ant-btn': {
            boxSizing: 'border-box',
            height: 28,
            borderRadius: 3,
            fontFamily: 'Open Sans',
            fontSize: 12,
            fontWeight: 600,
            laterSpacing: 0,
        },
        '& .ant-btn-ghost': {
            border: `1px solid ${theme.primaryColor} `,
            color: getFontColorFromHSL(theme.secondaryFillColor),
        },
        '& .ant-btn-primary, .ant-btn-primary:hover, .ant-btn-primary:focus': {
            backgroundColor: theme.primaryColor,
            color: getFontColorFromHSL(theme.secondaryFillColor),
        },
        '& .ant-dropdown-menu-submenu-title': {
            padding: '12px 4px',
        },
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector, .ant-input': {
            height: 28,
        },
        '& .ant-select-selector': {
            borderRadius: '4px 0 0 4px !important',
        },
        '& .ant-input': {
            borderLeft: 'none !important',
            borderRadius: '0 4px 4px 0 !important',
        },
    },
    selectFilter: {
        marginRight: '12px !important',
        width: '170px !important',
        '& .ant-select:not(.ant-select-customize-input) .ant-select-selector': {
            backgroundColor: '#fafafa',
        },
        '& .ant-select-selector': {
            width: 'auto !important',
            borderRadius: '6px !important',
            alignItems: 'center',
        },
        '& .ant-select-dropdown': {
            padding: '12px !important',
            borderRadius: '6px !important',
            gap: '16px !important',
        },
        '& .ant-select-item': {
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
            fontWeight: 600,
        },
        '& .ant-select-item-option-selected': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            color: getFontColorFromHSL(theme.tertiaryFillColor),
            padding: '8px !important',
            borderRadius: '4px !important',
            gap: '10px !important',
        },
    },
    dateFilter: {
        width: '100%',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        '& .ant-picker': {
            borderRadius: '6px',
            width: 215,
            height: 32,
        },
        '& .ant-picker-input > input': {
            fontSize: '13px',
        },
    },
    dateRange: {
        '& .ant-picker-cell-in-view::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-cell:hover .ant-picker-cell-in-view:hover::after': {
            display: 'none !important',
            content: 'none !important',
        },
        '& .ant-picker-panel-container': {
            backgroundColor: '#f7f7f7 !important',
            borderRadius: '4px !important',
            display: 'flex !important',
            flexDirection: 'row-reverse !important',
        },
        '& .ant-picker-cell-in-view .ant-picker-cell-inner': {
            display: 'flex !important',
            alignItems: 'center !important',
            justifyContent: 'center !important',
            width: '32px !important',
            height: '32px !important',
            padding: '0 !important',
            backgroundColor: 'white !important',
            borderRadius: '4px !important',
            margin: '1px !important',
            boxSizing: 'border-box !important',
            '&:hover': {
                backgroundColor: '#b9e0ff !important',
            },
        },
        '& .ant-picker-cell-in-view': {
            padding: '0 !important',
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            color: getFontColorFromHSL(theme.tertiaryFillColor),
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner, & .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner': {
            backgroundColor: `${theme.secondaryFillColor} !important`,
            color: getFontColorFromHSL(theme.secondaryFillColor),
            borderColor: `${theme.secondaryFillColor} !important`,
            fontWeight: 'bold !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-cell-disabled::before': {
            background: '#f7f7f7',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-date-panel .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after': {
            background: 'transparent !important',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before': {
            background: 'transparent !important',
        },
        '& .ant-picker-footer': {
            minWidth: 140,
            padding: 4,
        },
        '& .ant-picker-ranges .ant-picker-preset > .ant-tag-blue': {
            color: 'black',
            background: 'transparent !important',
            borderColor: 'transparent !important',
            fontWeight: 600,
            fontSize: '12px',
            padding: '8px',
        },
        '& .ant-picker-ranges > li:hover': {
            display: 'inline-block',
            backgroundColor: `${theme.tertiaryFillColor} !important`,
            color: getFontColorFromHSL(theme.tertiaryFillColor),
            borderRadius: '4px',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner': {
            color: getFontColorFromHSL(theme.secondaryFillColor),
        },
    },
    monthPicker: {
        '& .ant-picker-content td': {
            fontWeight: 600,
            justifyItems: 'center',
        },
        '& .ant-picker-header': {
            background: 'white',
        },
        '& .ant-picker-month-panel .ant-picker-body': {
            background: 'white',
        },
        '& .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner': {
            background: '#006ec3 !important',
            color: getFontColorFromHSL(theme.secondaryFillColor),
        },
    },
    filterText: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        marginRight: 8,
    },
    cellNa: {
        color: '#999999',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
    },
    cellValue: {
        color: '#111111',
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        cursor: 'pointer',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    downloadInvoiceBtn: {
        height: 12,
        width: 59,
        color: theme.primaryColor,
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: 0,
        lineHeight: 12,
    },
    pageFilter: {
        display: 'flex',
        marginBottom: 8,
        borderBottom: '1px solid #D9D9D9',
    },
    pageName: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        letterSpacing: 0,
        color: '#666666',
        padding: '12px 50px',
        cursor: 'pointer',
    },
    selectedPage: {
        fontSize: 14,
        fontFamily: 'Open Sans',
        fontWeight: 'bold',
        letterSpacing: 0,
        color: theme.primaryColor,
        padding: '12px 50px',
        borderBottom: `4px solid ${theme.primaryColor}`,
    },
    filter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    downloadButton: {
        marginRight: 12,
    },
    resetFilter: {
        color: '#DF1D1D',
        fontSize: 12,
        fontWeight: 600,
        cursor: 'pointer',
        marginLeft: 16,
        fontFamily: 'Open Sans',
    },
});
